import React from 'react';
import { Box, Step, StepLabel, Stepper, useTheme } from '@mui/material';
import { Check } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const CustomStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: 'rgba(255, 255, 255, 0.5)',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#fff',
  }),
  '& .CustomStepIcon-completedIcon': {
    color: '#fff',
    zIndex: 1,
    fontSize: 18,
  },
  '& .CustomStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

function CustomStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <CustomStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="CustomStepIcon-completedIcon" />
      ) : (
        <div className="CustomStepIcon-circle" />
      )}
    </CustomStepIconRoot>
  );
}

const StepIndicator = ({ currentStep, totalSteps }) => {
  const theme = useTheme();
  
  const steps = [
    'Email',
    'Code OTP',
    'Validation',
    'Nouveau mot de passe'
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper 
        activeStep={currentStep - 1} 
        alternativeLabel
        sx={{
          '& .MuiStepLabel-root': {
            color: 'rgba(255, 255, 255, 0.7)',
          },
          '& .MuiStepLabel-label': {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '0.75rem',
            fontWeight: 500,
            '&.Mui-active': {
              color: '#fff',
              fontWeight: 600,
            },
            '&.Mui-completed': {
              color: '#fff',
              fontWeight: 500,
            },
          },
          '& .MuiStepConnector-root': {
            top: 11,
            left: 'calc(-50% + 16px)',
            right: 'calc(50% + 16px)',
          },
          '& .MuiStepConnector-line': {
            height: 2,
            border: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            borderRadius: 1,
          },
          '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': {
            backgroundColor: '#fff',
          },
          '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
            backgroundColor: '#fff',
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel StepIconComponent={CustomStepIcon}>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default StepIndicator;